import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { paths } from '@constants/paths';
import { useAppointmentContext } from '@providers/AppointmentProvider/AppointmentContext';
import { useAuthContext } from '@services/Auth/context';

const AuthGuard = () => {
  const { activeClient } = useAuthContext();
  const { appointment, hasCustomer } = useAppointmentContext();
  const location = useLocation();
  const isEndingAppointment = location.state?.isEndingAppointment;

  if (
    appointment &&
    !appointment.isEnded &&
    hasCustomer &&
    !isEndingAppointment
  ) {
    return <Navigate to={paths.address} replace />;
  }

  if (!activeClient) {
    return <Navigate to={paths.root} replace />;
  }

  return <Outlet />;
};

export { AuthGuard };
